@if (
  endorsementLocation?.isSignableInCurrentSession &&
  endorsementLocation?.statusCode !== 'SIGNED' &&
  endorsementLocation?.isRequired
  ) {
  <span class="endorsement-flag endorsement-flag--required"
    data-testid="endorsement-flag-req">
    Action Item
  </span>
}

@if (
  endorsementLocation?.isSignableInCurrentSession &&
  endorsementLocation?.statusCode !== 'SIGNED' &&
  !endorsementLocation?.isRequired
  ) {
  <span class="endorsement-flag endorsement-flag--optional"
    data-testid="endorsement-flag-optional">
    Optional Item
  </span>
}
